// extracted by mini-css-extract-plugin
module.exports = {"notification":"styles_notification__3JhES","error":"styles_error__3v5Ss","success":"styles_success__KQ8Cc","info":"styles_info__1IShv","warning":"styles_warning__1h1VL"};